import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'

class PreventCopyContents extends Component {
    @autobind
    handleChange(value, property) {
        const { onChange } = this.props
        let newObject = {};
        newObject[property] = value;
        onChange(
            Object.assign({},  this.props.data, {
                setting: Object.assign({},  this.props.data.setting, newObject),
                validated: true
            })
        )
    }

    render() {
        const { plugin, data } = this.props;
        return (
            <div className="desc_plugin23">
                <p className="txt_plugin">
                    마우스 오른쪽 클릭을 통한 복사 행위를 금지해 글 및 이미지 무단 복사를 제한합니다.<br/>
                    다만 일부 브라우저 환경에서는 정상적으로 작동하지 않을 수 있습니다.
                </p>
                {this.props.saveButton()}
            </div>
        )
    }
}

PreventCopyContents.propTypes = {
    plugin: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired
}

export default PreventCopyContents
